const hasPermission = {
	install(Vue, options) {
		Vue.directive('has', {
			bind(el, binding, vnode) {
				let del = false
				let permTypes = sessionStorage.getItem('displayButtonList');
				if (permTypes != null) {
					if (!permTypes.includes(binding.value)) {
						del = true
					}
				}
				Vue.nextTick(function() {
					if (el.parentNode && el.parentNode.parentNode && el.parentNode.parentNode.parentNode && el.parentNode.parentNode.parentNode.rowIndex == 0) {
						let totalWidth = 0;
						const children = el.parentNode.children;
						for (let child of children) {
							if (child != el || !del) {
								totalWidth += child.offsetWidth + 20;
							}
						}
						vnode.context.width = totalWidth + 5;
					}
					if (del) {
						el.parentNode.removeChild(el);
					}
				})
			}
		});
	}
};

export default hasPermission;


// WEBPACK FOOTER //
// ./src/components/libs/hasPermission.js